/**
 * 「誰が・いつ更新したか」「いつ書き出したか」を記録するための共有ヘルパ。
 * 3つのストア (propertyStore v1 / propertyStoreV2 / smokingStore) が使う。
 *
 * 記録先を updateProperty の中に閉じ込めているのは、書き出しが3箇所
 * (各エディタ) から `{ status: 'exported' }` の更新として
 * 行われるため — 呼び出し側に日時の記録を配ると、足し忘れが起きる。
 */
import { nowIso } from '@/lib/id';
import { useAuthStore } from './authStore';

/**
 * 一覧に出す最終更新者。
 *
 * Firebase 無効モードでは authStore が 'local@dev' を返す。ログイン前など
 * email が無いときは記録しない (undefined) — 嘘の名前を残すより空の方がよい。
 */
export function currentEditor(): string | undefined {
  return useAuthStore().email ?? undefined;
}

/**
 * 更新パッチに更新者を足す。書き出し (status='exported') なら書き出し日時も。
 * updatedAt は各ストア/crud が別途更新する。
 *
 * 任意のパッチを受けるため制約は object のみ。status を持つ型に絞ると、
 * 「名前だけ変える」等の status を含まないパッチを渡せなくなる。
 */
export function withEditStamp<T extends object>(
  patch: T,
): T & { updatedBy?: string; exportedAt?: string } {
  const stamped: T & { updatedBy?: string; exportedAt?: string } = {
    ...patch,
    updatedBy: currentEditor(),
  };
  if ((patch as { status?: unknown }).status === 'exported') {
    stamped.exportedAt = nowIso();
  }
  return stamped;
}
